import styled from "styled-components";

export const Input = styled.textarea`
    width: 100%;
    min-height: 120px;
    border: 0.5px solid #CCC;
    color: ${props => props.theme.colors.primaryText};
    border-radius: 17.5px;
    padding: 10px 17.5px;
`;